import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '../../../components/svg-icon/svg-icon.component';
import { PillSoonComponent } from '../../atoms/pill-soon/pill-soon.component';
import { SvgIcon } from '@services/svg-icon.service';


export interface MenuButtonData {
  iconSrc: string;
  title: string;
  showPill?: boolean;
  pillText?: string;
}

/**
 * MenuButton component for navigation menu options
 * 
 * @example
 * ```html
 * <ds-menu-button 
 *   [data]="buttonData"
 *   (click)="onButtonClick()"
 * ></ds-menu-button>
 * ```
 */
@Component({
  selector: 'ds-menu-button',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, PillSoonComponent],
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent {
  readonly SvgIcon = SvgIcon;

  data = input.required<MenuButtonData>();
  click = output<void>();

  onClick(): void {
    this.click.emit();
  }
}